export default "__VITE_ASSET__f7ae66c2__"